import AbstractProvidedClass from "../../shared/AbstractProvidedClass";
import Buttons from "./Fields/Buttons";
import InputField from "./Fields/InputField";
import ModeSelector from "./Fields/ModeSelector";
import MultiField from "./Fields/MultiField";
import SimpleField from "./Fields/SimpleField";
import SelectionOverview from "./Fields/SelectionOverview";
import SpeciesList from "./Fields/SpeciesList";
import LabelField from "./Fields/LabelField ";
import AreaField from "./Fields/AreaField";
import NameField from "./Fields/NameField";

export default class Input extends AbstractProvidedClass {
    inputs = [];
    element = null;

    constructor(provider, tabContainer) {
        super(provider);

        this.container = this.p.createDiv()
            .parent(tabContainer)
            .style('height', (this.p.height - 20) + 'px')
            .class('pad-b');

        this.createTitle();
        this.createLabel();
        this.createNotes();
        this.createSpecies();
        this.createDimensions();
        this.createSelected();
        this.createButtons();

        this.hide();
    }

    setElement(element) {
        this.element = element;
        if (!this.element) {
            return;
        }
        this.inputs.map((input) => input.setElement(element));
        if (this.selection.length > 1) {
            this.title.value(element.title + ' (' + this.selection.length + ')');
            this.multiInput.hide();
            let items = this.selection.items;
            [this.label, this.size, this.width, this.height].map((input) => {
                let same = true;
                let i = 0;
                while (same && items[i + 1]) {
                    same = items[i][input.attributeValue] === items[i + 1][input.attributeValue];
                    i++;
                }
                if (!same) {
                    input.value('');
                }
            });
        }
    }

    setDrawMode(type) {
        this.inputs.map((input) => input.setDrawMode(type));
    }

    reset() {
        this.inputs.map((input) => input.isInputField ? input.reset() : null);
    }

    registerInput(input) {
        input.parent(this.container)
        this.inputs.push(input);
        input.hide();
    }

    showSelection() {
        this.element = null;
        this.drawMenu.hide();
        this.inputs.map((input) => input.hide());
        this.title.value('Selection');
        this.title.show();
        this.selected.update();
        this.selected.show();
        this.buttons.all();
        this.buttons.show();
    }

    showInfo() {
        if (this.element) {
            this.drawMenu.show('element');
            this.drawMenu.setAppearance(this.element.appearance);
        }
    }

    createTitle() {
        this.title = NameField.setup(this.provider)
            .make();
        this.registerInput(this.title);
    }

    createLabel() {
        this.label = LabelField.setup(this.provider)
            .hideInDrawMode()
            .make();
        this.registerInput(this.label);
    }

    createNotes() {
        this.notes = AreaField.setup(this.provider)
            .hideInDrawMode()
            .make();
        this.registerInput(this.notes);
    }

    createDimensions() {
        this.dimensions = SimpleField.setup(this.provider)
            .setType('h3')
            .setStaticValue('Dimensions')
            .style('margin-bottom', '0px')
            .make();
        this.registerInput(this.dimensions);

        this.createSize();
        this.createWidth();
        this.createHeight();
        this.createMultiInput();
    }

    createSpecies() {
        this.createSpeciesList();
    }

    createSpeciesList() {
        this.speciesList = SpeciesList.setup(this.provider)
            .make();
        this.registerInput(this.speciesList);
    }

    createSize() {
        this.size = InputField.setup(this.provider)
            .dimension()
            .label('Size')
            .attribute('size')
            .style('margin-top', '5px')
            .setPopulate((element, field) => field.value(element.displaySize))
            .types(['ellipse'])
            .make();
        this.registerInput(this.size);
    }

    createWidth() {
        this.width = InputField.setup(this.provider)
            .dimension()
            .label('Width')
            .attribute('width')
            .setPopulate((element, field) => field.value(element.displayWidth))
            .types(['rectangle'])
            .make();
        this.registerInput(this.width);
    }

    createHeight() {
        this.height = InputField.setup(this.provider)
            .dimension()
            .label('Height')
            .attribute('height')
            // .style('margin-top', '5px')
            .setPopulate((element, field) => field.value(element.displayHeight))
            .types(['rectangle'])
            .make();
        this.registerInput(this.height);
    }

    createMultiInput() {
        this.multiInput = MultiField.setup(this.provider)
            .class('input-group')
            // .style('margin-top', '5px')
            .types(['polygon', 'line'])
            .make();
        this.registerInput(this.multiInput);
    }

    createSelected() {
        this.selected = SelectionOverview.setup(this.provider)
            .make();
        this.registerInput(this.selected);
    }

    createButtons() {
        this.buttons = Buttons.setup(this.provider)
            .make();
        this.registerInput(this.buttons);
    }

    show() {
        this.container.show();
    }

    hide() {
        this.container.hide();
    }
}
